import { guestStoreService } from "@/services/store.service";

const COMPANY_ULID = process.env.NEXT_PUBLIC_COMPANY_ULID ?? "";

/**
 * Livre-t-on à cet endroit ?
 *
 * L'API le dit, et le web ne l'écoutait pas. Mesuré sur un point du grand sud
 * (Tamanrasset) :
 *
 *   PUT /customer/location  →  { latitude, longitude, zone_ulid: null }
 *   GET /stores             →  0 magasin
 *
 * Le client voyait donc un catalogue vide, sans un mot d'explication — ce qui
 * se lit comme « la plateforme est cassée » aussi bien que comme « on ne livre
 * pas chez moi ». Et le sélecteur d'adresse n'opposait aucune résistance : sa
 * vérification de zone ne s'exécutait que depuis le panier, pour protéger une
 * commande en cours (`guardStoreUlid`). Choisir une adresse depuis l'en-tête
 * ou la fenêtre de localisation acceptait n'importe quel point du globe.
 *
 * La sonde passe TOUJOURS par l'endpoint invité, même pour un client connecté.
 * `PUT /customer/location` renvoie certes `zone_ulid`, mais il DÉPLACE la
 * position du compte : sonder avec lui reviendrait à déménager le client avant
 * même qu'il ait validé son choix, et à le laisser ailleurs s'il renonce. La
 * liste invitée, elle, ne modifie rien — et distingue aussi bien : mesuré,
 * 0 magasin à Tamanrasset, 3 à El Achour comme à Oran.
 */
export type Coverage = "covered" | "uncovered" | "unknown";

export async function checkCoverage(latitude: number, longitude: number): Promise<Coverage> {
  try {
    const stores = await guestStoreService.list({
      latitude,
      longitude,
      company_ulid: COMPANY_ULID,
      page: 1,
      limit: 1,
    });
    return Array.isArray(stores) && stores.length === 0 ? "uncovered" : "covered";
  } catch {
    // Réseau, API indisponible… : on ne bloque pas le client sur une
    // incertitude, il vaut mieux le laisser passer que l'enfermer à tort.
    return "unknown";
  }
}
